import { useEffect, useState } from "react";
import { url } from "../../Values/constants";
import axiosHandler from "../../Services/axiosHandler";
import { useHistory } from "react-router";
import { createOrder, pgiAutoLogin, recurringPaySetup } from "../../Services/pgi";
import styles from "./FreeTrialActivatedModal.module.css";
import { connect, useDispatch } from "react-redux";


interface FreeTrialActivatedModalProps {
    props?: any;
    setShowTrialActivatedModal: (open: boolean) => void;
    result?: any;
    price?: any;
    unit?: any;
    Id?: any;
    validityDays?: any;
    name?: any;
    date?: any;
    orignalPrice?: any;
    user?: any;
    validTill?: any;
    planName?: any;
    packageId?:any;
    topUp?:any,
    uotPayStatus?:any,
    recurringPayStatus?:any
    tag?:any
    responseGst?:any
  }
const FreeTrialActivatedModal: React.FC<FreeTrialActivatedModalProps> = ({
    setShowTrialActivatedModal,
  result,
  price,
  unit,
  Id,
  validityDays,
  name,
  date,
  orignalPrice,
  user,
  validTill,
  planName,
  packageId,
  topUp,
  uotPayStatus,
  recurringPayStatus,
  tag,
  responseGst
}) => {

    const [isRechargeFailed, setIsRechargeFailed] = useState<boolean>(result);
    const section = JSON.parse(localStorage.getItem("gstData") || "{}");
    const [token, setToken] = useState<any>();
    const [data, setdata] = useState<any>();
    const history = useHistory();
  // console.log("section",section)
    const closeHandler = () => {
      setShowTrialActivatedModal(false);
      document.body.classList.remove("no-overflow");
      window.location.href = "/marketing"; // Full reload
    };
  // console.log("result packageId",packageId)
    useEffect(() => {
      if (token) {
        // console.log("result packageId22222",packageId)
        createOrder(
          section.gstno,
          user.user_super_oid,
          orignalPrice,
          orignalPrice,
          packageId,
          token,
          recurringPayStatus,
        );
      }
    }, [token]);
  
    const tagGet = async (id:any) => {
      const apiUrl = url+"/miscellaneous/getTag";
      const payload = {
        id:id,
      };
    // console.log("sendMail--payload",payload)
      try {
        const response = await axiosHandler.post(apiUrl, payload);
      //  console.log("miscellaneous done response",response)
       return response.data.data
      } catch (error:any) {
        // Handle errors
        // console.error("Error fetching responses:", error.response || error);
        throw error;
      }
    };

    useEffect(() => {
        const fetchData1 = async () => {
            const tagData:any = await tagGet(tag)
            setdata(tagData)
        }
        fetchData1()
      }, [tag]);
  
    useEffect(() => {
      const fetchData = async () => {
      const emailSentKey = `emailSent_${Id}`; // Unique key based on the transaction ID
      const tagKey = `tag_${Id}`;
      const userName = `${user?.user_first_name} ${user?.user_last_name}`
      const userEmail = user?.user_email
      if (result === false && !localStorage.getItem(emailSentKey) && userName && userEmail && user.user_super_oid && uotPayStatus) {
        // if(user){
          sendMail(Id, planName,userName,userEmail);
          updateReadPro(Id,user.user_super_oid)
          if(uotPayStatus==='50000'){
            ifPending()
          }
          if(recurringPayStatus==="Y"){
            const tagId:any = await tagGet(tag)
            // setdata(tagId)
            // console.log("tagId tagGet",tagId)
            // recurringPaySetup(user.organization_id,user.user_super_oid,Id,tagId.actual_packId,tagId.actual_amount)
            if(tagId && !localStorage.getItem(tagKey)){
              recurringPaySetup(user.organization_id,user.user_super_oid,Id,packageId,price,tagId.actual_packId,tagId.actual_amount,section.gstno)
              localStorage.setItem(tagKey, "true"); 
            }
          }
          localStorage.setItem(emailSentKey, "true"); 
        // }
      }else{
        if(uotPayStatus==='50000'){
          ifPending()
        }
      }
    }
    fetchData();
    }, [result, Id, planName,user,uotPayStatus]);
  
  
    const sendMail = async (id: any, planName: any,userName:any,userEmail:any) => {
      const apiUrl = url + "/pgi/sendMail";
      
      const payload = {
        email_id: userEmail,
        name: userName,
        amount: orignalPrice,
        transactionId: id,
        planName: planName,
        validity: validTill,
        credits: unit,
        result: result,
        dateTime: date,
        topUp:topUp
      };
      try {
        // console.log("payload mail",payload)
        const response = await axiosHandler.post(apiUrl, payload);
        // console.log("Mail Sent");
      } catch (error: any) {
        // console.error("Error fetching responses:", error.response || error);
        throw error;
      }
    };
  
    const updateReadPro = async (id: any, oid: any) => {
      const apiUrl = url + "/pgi/readProDataPunch";
      let payload 
      
      const tagId:any = await tagGet(tag)
      // console.log("tag__updateReadPro",tag)
      // console.log("tagId__updateReadPro",tagId)
      {(tagId.free_trial === "ft" && recurringPayStatus !== "Y")?payload= {
        oid: oid,
        id: id,
        tag:"ft"
      }:
      payload= {
        oid: oid,
        id: id,
      }}
      try {
        const response = await axiosHandler.post(apiUrl, payload);
        // console.log("ReadPro data updated");
      } catch (error: any) {
        // console.error("Error ReadPro data updated responses:", error.response || error);
        throw error;
      }
    };
  
    const ifPending = async () => {
      const apiUrl = url + "/pgi/purchagePending";
      const payload = {
        organization_id: user.organization_id,
              package_id: packageId,
              oid: user.user_super_oid,
              payState: 50000,
              orderId: Id,
      };
      try {
        // console.log("payload_ifPending",payload);
        const response = await axiosHandler.post(apiUrl, payload);
        // console.log("ReadPro data updated");
      } catch (error: any) {
        // console.error("Error ReadPro data updated responses:", error.response || error);
        throw error;
      }
    };
  
    return (
        <div className={styles.fta}>
            <div className={styles.head}>
                <div className={styles.title}>Trial Activated</div>
                <div className={styles.subTitle}><span className={styles.rupees}>&#8377;</span>500 Credited</div>
            </div>
            <div className={styles.content}>
                <div className={styles.details}>
                    <div className={styles.detailsItem}>
                        Price
                        <div className={styles.detailsItemVal}><span className={styles.strikeThrough}><span className={styles.rupees}>&#8377;</span>500</span><span className={styles.rupees}>&#8377;</span>{orignalPrice}</div>
                    </div>
                    <div className={styles.detailsItem}>
                        Validity
                        <div className={styles.detailsItemVal}>{validityDays}</div>
                    </div>
                    <div className={styles.detailsItem}>
                        Credits
                        <div className={styles.detailsItemVal}>{unit}</div>
                    </div>
                </div>
                <div className={styles.label}>Transaction ID <div className={styles.green}>{Id}</div></div>
                <div className={styles.label}>Date & Time <div>{date}</div></div>
                <div className={styles.label}>User <div className={styles.semiBold}>{name}</div></div>
                <div className={styles.label}>Next billing <div>on 90% consumption</div></div>
                <div className={styles.label}>Next bill amount <div className={styles.semiBold}><span className={styles.rupees}>&#8377;</span>{data?.actual_amount ?? "N/A"}</div></div>
            </div>
            <div className={styles.ctaPrim} onClick={closeHandler}>Explore Whatsapp Marketing</div>
        </div>
    )
}
const mapStateToProps = (state: any) => {
    return {
      user: state.user.data,
      organizationData: state.organization.organizationData,
    };
  };


export default connect(mapStateToProps)(FreeTrialActivatedModal)